import type { ToolCallEntry } from "../ChatBox/types";

/**
 * Merge incoming tool calls into the accumulated list.
 * Updates existing entries (by toolId) so that results from completed
 * tool calls replace the initial empty-results placeholder.
 */
export function mergeToolCalls(
  accumulated: ToolCallEntry[],
  incoming: ToolCallEntry[]
): ToolCallEntry[] {
  const merged = [...accumulated];
  for (const tool of incoming) {
    const existingIndex = merged.findIndex(t => t.toolId === tool.toolId);
    if (existingIndex >= 0) {
      merged[existingIndex] = tool;
    } else {
      merged.push(tool);
    }
  }
  return merged;
}
